// Los textos que muestran las pantallas del módulo FERIAS, en español (diseño §4 de fct-ferias).
import type { MotivoRechazo } from '../../api/feriasApi';

/** Lo que muestra una celda sin dato. */
export const SIN_DATO = '—';

/** Por qué un archivo no se convirtió en caso, como lo lee el usuario. */
export const MOTIVO_RECHAZO: Record<MotivoRechazo, string> = {
  'no-pdf': 'No es un PDF.',
  ilegible: 'El PDF está dañado y no se puede leer.',
  paginas: 'No tiene exactamente dos páginas.',
  'demasiado-grande': 'Ocupa más de 10 MB.',
  'nombre-demasiado-largo': 'El nombre del archivo tiene más de 260 caracteres.',
  'error-almacenamiento': 'No se ha podido guardar. Vuelva a subirlo.',
};

// La zona horaria de los usuarios: las horas de entrada se muestran en ella, y la API cuenta en ella
// los días de entrada, sea cual sea la zona del navegador.
const HORA_DE_MADRID = new Intl.DateTimeFormat('es-ES', {
  timeZone: 'Europe/Madrid',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** Un instante (ISO con zona) como «03/11/2026 10:15» en la hora de Madrid. */
export function fechaHoraMadrid(iso: string): string {
  const partes = Object.fromEntries(HORA_DE_MADRID.formatToParts(new Date(iso)).map((p) => [p.type, p.value]));
  return `${partes.day}/${partes.month}/${partes.year} ${partes.hour}:${partes.minute}`;
}

/** Un día de calendario como lo manda la API (aaaa-mm-dd), mostrado como 24/09/2026, sin zona horaria. */
export function dia(iso: string | null): string {
  if (!iso) {
    return SIN_DATO;
  }
  const [anio, mes, d] = iso.split('-');
  return `${d}/${mes}/${anio}`;
}

/** «#12», «#12 y #15», «#12, #15 y #20». */
export function listaCasos(ids: number[]): string {
  const nombres = ids.map((id) => `#${id}`);
  if (nombres.length <= 1) {
    return nombres.join('');
  }
  return `${nombres.slice(0, -1).join(', ')} y ${nombres[nombres.length - 1]}`;
}
